export class SubscriptionMenuId {
  private readonly _brand = SubscriptionMenuId.name;
  constructor(public readonly value: string) {}
}
